// ======================================================================
// وضع الاختبار: اجعل التوكن ينتهي بعد مدة قصيرة (بالمللي ثانية) من وقت إصداره
// ضع null لإيقاف وضع الاختبار والرجوع لمدة التوكن الحقيقية من السيرفر
// ======= ========================= ====================== ================
const TEST_EXPIRY_MS = null;

export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
export const TOKEN_REFRESH_THRESHOLD_MS = 5 * 60 * 1000;

// ── الخدمة المحلية لنقطة البيع (localhost): هي التي تتحقق من الجلسة — صالحة 16 ساعة من الدخول
//    حتى لا يخرج الكاشير وسط الوردية عند انتهاء توكن السيرفر وهو بدون إنترنت.
const AGENT = typeof window !== "undefined" && window.__PROFIT_AGENT__ === true;
const AGENT_SESSION_MS = 16 * 60 * 60 * 1000;
const isLocalToken = (t) => typeof t === "string" && t.startsWith("pl.");

function decodePayload(token) {
  const part = token.split(".")[1];
  if (!part) throw new Error("Invalid token");
  let b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  while (b64.length % 4) b64 += "=";
  const binary = atob(b64);
  const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}

export function getTokenExpiryMs(token) {
  if (!token) return 0;

  // توكن الدخول بدون إنترنت (ليس JWT) — الخدمة المحلية ترفضه بنفسها عند انتهائه
  if (AGENT && isLocalToken(token)) return Date.now() + AGENT_SESSION_MS;

  try {
    const payload = decodePayload(token);

    if (TEST_EXPIRY_MS != null) {
      const issuedSec = payload.iat || payload.nbf;
      let issuedMs = issuedSec ? issuedSec * 1000 : Number(localStorage.getItem("tokenTestStart"));
      if (!issuedMs) {
        issuedMs = Date.now();
        localStorage.setItem("tokenTestStart", String(issuedMs));
      }
      const realExpiry = payload.exp ? payload.exp * 1000 : Infinity;
      return Math.min(issuedMs + TEST_EXPIRY_MS, realExpiry);
    }

    const expiryMs = payload.exp ? payload.exp * 1000 : 0;

    // داخل الخدمة المحلية: الجلسة 16 ساعة من الدخول (والتجديد يتم عند أول رد 401 من السيرفر)
    if (AGENT) {
      const issuedSec = payload.iat || payload.nbf;
      return Math.max(expiryMs, issuedSec ? issuedSec * 1000 + AGENT_SESSION_MS : 0);
    }

    return expiryMs;
  } catch {
    return 0;
  }
}

export function isTokenValid(token) {
  const expiryMs = getTokenExpiryMs(token);
  return expiryMs > 0 && Date.now() < expiryMs;
}

export function getMsUntilExpiry(token) {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) return 0;
  return Math.max(0, expiryMs - Date.now());
}

export function shouldRefreshTokenSoon(token) {
  if (AGENT && isLocalToken(token)) return false;
  const msLeft = getMsUntilExpiry(token);
  return msLeft > 0 && msLeft <= TOKEN_REFRESH_THRESHOLD_MS;
}

const LAST_ACTIVITY_KEY = 'lastActivityAt';

export function updateLastActivity() {
  const now = Date.now();
  localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
}

export function getLastActivityMs() {
  const stored = localStorage.getItem(LAST_ACTIVITY_KEY);
  if (!stored) return 0;
  const ms = Number(stored);
  return isNaN(ms) ? 0 : ms;
}

export function getMsUntilIdleExpiry() {
  const lastActivity = getLastActivityMs();
  if (!lastActivity) return 0;
  return Math.max(0, (lastActivity + IDLE_TIMEOUT_MS) - Date.now());
}

export function isSessionActive() {
  const lastActivity = getLastActivityMs();
  if (!lastActivity) return false;
  return (Date.now() - lastActivity) < IDLE_TIMEOUT_MS;
}

export function getAllowedBranchIds() {
  const stored = localStorage.getItem('allowedBranchIds');
  if (!stored) return [];
  try {
    const arr = JSON.parse(stored);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function isBranchAllowed(branchId) {
  if (branchId == null) return false;
  const allowed = getAllowedBranchIds();
  // ✅ القاعدة: إذا كانت القائمة فارغة → المستخدم له صلاحية على كل الفروع (الكل مسموح)
  if (allowed.length === 0) return true;
  return allowed.includes(Number(branchId));
}

export function clearAuthStorage() {
  const keysToRemove = [
    'token',
    'refreshToken',
    'permissions',
    'companyId',
    'branchId',
    'userId',
    'userName',
    'companyName',
    'mobile',
    'safeId',
    'stockId',
    'allowedSafeIds',
    'allowedStockIds',
    'allowedBranchIds',
    'tokenTestStart',
    LAST_ACTIVITY_KEY
  ];
  keysToRemove.forEach(key => localStorage.removeItem(key));
}